import { render, staticRenderFns } from "./healthexaminationDetail.vue?vue&type=template&id=2560d525&"
import script from "./healthexaminationDetail.vue?vue&type=script&lang=js&"
export * from "./healthexaminationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports